import * as React from "react";

export const CheckedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 1792 1792" fill="#44C997" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1299 813l-422 422q-19 19-45 19t-45-19l-294-294q-19-19-19-45t19-45l102-102q19-19 45-19t45 19l147 147 275-275q19-19 45-19t45 19l102 102q19 19 19 45t-19 45zm141 83q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" />
  </svg>
);

export const CheckedIcon2 = ({ color = "#000000", ...props }: React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg fill={color} viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1827.701 303.065 698.835 1431.801 92.299 825.266 0 917.564 698.835 1616.4 1919.869 395.234z"
      fillRule="evenodd"
    />
  </svg>
);
